<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="e911-location-name">
        <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.LOCATION_NAME" | translate }}s</div>
        <div>{{ e911Location.locationName }}</div>
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.EMERGENCY_RESPONSE_LOCATION" | translate }}
      </div>
      <div>
        <span>{{ e911Location.streetNumber + " " + e911Location.streetName }}</span>
        <!-- The secondary address is optional -->
        @if (e911Location.addressType || e911Location.addressTypeNumber) {
        <span>,&nbsp;</span>
        } @if (e911Location.addressType) {
        <span>{{ e911Location.addressType }}</span>
        } @if (e911Location.addressTypeNumber) {
        <span>&nbsp;{{ e911Location.addressTypeNumber }}</span>
        }
        <br />
        <span>{{
          e911Location.city + ", " + e911Location.state + " " + e911Location.zipcode
        }}</span>
        <br />
        <span>{{
          e911Location.country === "US"
            ? ("ONSIP_I18N.UNITED_STATES_OF_AMERICA" | translate)
            : e911Location.country
        }}</span>
      </div>
    </section>
  </div>
  <div class="second-column">
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.ADDRESS_TYPE" | translate }}</div>
      <div>{{ e911Location.locationType }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.NOTIFICATION_EMAIL_ADDRESS" | translate }}</div>
      <div>{{ e911Location.notificationEmail || "ONSIP_I18N.NONE" | translate }}</div>
    </section>
  </div>
  <div class="third-column">
    <section>
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.ASSIGNED_USERS" | translate }} ({{ e911Location.assignedAddressCount }})
      </div>
      <onsip-item-list
        [listItems]="assignedUsers"
        [itemNamePlural]="'assigned users'"
      ></onsip-item-list>
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" (click)="togglePanel()" color="primary">
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
